export function getEntityFromLocationSearch(search) {
  const searchParams = new URLSearchParams(search);
  const projectId = searchParams.get("project");
  const documentId = searchParams.get("document");

  return {projectId, documentId};
}
